import m from 'mithril'

export default m.trust(`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" style="width: var(--icon-width, 10px); height: var(--icon-height, 10px);">
		<path stroke="var(--icon-color, currentColor)" d="M9 1L1 9M1 1L9 9"/>
	</svg>
`)
